import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Heading } from "@nju/ui";
import { OnboardingMembersInfoList } from "./partials";

interface IOnboardingMembersInfoProps {
  multiOrder: IMultiOrderOrchestrator | undefined;
  isMulti: boolean;
  screenVariant?: "failed" | "success";
}

export function OnboardingMembersInfo({
  multiOrder,
  isMulti,
  screenVariant,
}: IOnboardingMembersInfoProps) {
  return (
    <>
      <Heading
        className="sm:mb-3 mb-4 mt-6"
        font="ttfirs"
        tone="neutral"
        variant="h4"
        weight="bold"
      >
        Twoje zamówienie
      </Heading>
      <OnboardingMembersInfoList
        isMulti={isMulti}
        multiOrder={multiOrder}
        screenVariant={screenVariant}
      />
    </>
  );
}
